import React from 'react';

function Services() {
  return (
    <div className="page-container">
      <div className="header-container">Services</div>
      <div className="text-container">
      We offer a comprehensive range of construction consulting services designed 
      to meet the unique needs of each project. Our expertise spans across residential, commercial, 
      and industrial sectors, ensuring that every detail is expertly managed for optimal results. Our services include:

      <ul>
        <li>
          <b>Project Planning & Design:</b> We help you shape your vision with innovative designs, 
          ensuring every aspect of the project aligns with your goals and budget.
        </li>
        <li>
        <b>Construction Management:</b> Our team oversees every phase of construction, 
          providing expert guidance and ensuring projects are completed on time and within budget.
        </li>
        <li>
        <b>Cost Estimating & Budgeting:</b> We provide accurate and detailed cost estimates to 
          help you make informed decisions, manage expenses, and avoid unexpected costs.
        </li>
        <li>
        <b>Risk Management:</b> We identify potential risks and create strategies to mitigate them, 
          ensuring smooth project execution from start to finish.
        </li>
        <li>
        <b>Quality Control & Inspection:</b> Our experts ensure that all work meets the highest 
          industry standards and is completed with precision and care.
        </li>
      </ul>
      Let us support you in your next construction project with our tailored consulting services.
      </div>
    </div>
  );
}

export default Services;
